import { CheckCircle } from '@material-ui/icons';
import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import React from 'react';
import { connect } from 'react-redux';
import { Field, change, reduxForm } from 'redux-form';
import { GREEN } from '../../../_config/consts.js';
import * as formatter from '../../../_config/formatter';
import FormCardContainer from '../Elements/FormCardContainer.jsx';
import DatePickerField from '../Fields/DatePickers/SingleDatePicker/DatePickerField.jsx';
import GuestSelector from '../Fields/GuestSelector.jsx';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import SelectableRowField from '../Fields/SelectableRows/SelectableRowField.jsx';
import TimePickerField from '../Fields/TimePicker/TimePickerField.jsx';
import NativeTimeInputField from '../Fields/TimePicker/NativeTimeInputField.jsx';
import CustomField from '../Fields/CustomField.jsx';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import UserOutlineIconCustom from '../../CustomIcons/UserOutlineIconCustom.jsx';
import CalendarClockIconCustom from '../../CustomIcons/CalendarClockIconCustom.jsx';
import AgendaIconCustom from '../../CustomIcons/AgendaIconCustom.jsx';
import CopyIconCustom from '../../CustomIcons/CopyIconCustom.jsx';

const validate = (values) => {
  const errors = {};
  const period = moment(values.dateTo).diff(moment(values.dateFrom), 'hours');
  if (!values.firstname || (values.firstname && values.firstname.length === 0)) {
    errors.firstname = 'required';
  }
  if (period > 420) {
    errors.dateTo = 'tooManyDaysSelected';
  }
  if (period < 0) {
    errors.dateTo = 'endDateAfterFromDate';
  }
  if (!values.resourceId) {
    errors.resourceId = 'required';
  }
  return errors;
};

@reduxForm({ form: 'ReservationForm', validate })
@connect(state => ({ form: state.form.ReservationForm }))
class ReservationForm extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filterTimeout: '',
      isMultidayMode: false
    }
  }

  onHandleChange(value, field, resourceName, page) {
    const { dateHasBeenChanged, form, onGuestTagsChange, dispatch } = this.props;
    const { isMultidayMode } = this.state;
    let dateInterval = {};
    let userTagId = '';
    switch (field) {
      case 'dateFrom':
        dateInterval = {
          start: value,
          end: isMultidayMode ? form.values.dateTo || value : value,
          startTime: form.values.timeFrom,
          endTime: form.values.timeTo,
        };
        userTagId = form.values.firstname ? form.values.firstname.id : '';
        break;
      case 'dateTo':
          dateInterval = {
            start: form.values.dateFrom,
            end: value,
            startTime: form.values.timeFrom,
            endTime: form.values.timeTo,
          };
          userTagId = form.values.firstname ? form.values.firstname.id : '';
          break;
      case 'timeFrom': {
        const prevFrom = form.values.timeFrom ? moment(form.values.timeFrom) : null;
        const prevTo = form.values.timeTo ? moment(form.values.timeTo) : null;
        const deltaMs = prevFrom && prevTo && prevTo.isAfter(prevFrom)
          ? prevTo.diff(prevFrom)
          : 60 * 60 * 1000;
        const nextTo = moment(value).add(deltaMs, 'milliseconds').valueOf();
        dispatch(change('ReservationForm', 'timeTo', nextTo));
        dateInterval = {
          start: form.values.dateFrom,
          end: isMultidayMode ? form.values.dateTo : form.values.dateFrom,
          startTime: value,
          endTime: nextTo,
        };
        userTagId = form.values.firstname ? form.values.firstname.id : '';
        break;
      }
      case 'timeTo':
        dateInterval = {
          start: form.values.dateFrom,
          end: isMultidayMode ? form.values.dateTo : form.values.dateFrom,
          startTime: form.values.timeFrom,
          endTime: value,
        };
        userTagId = form.values.firstname ? form.values.firstname.id : '';
        break;
      case 'firstname':
        dateInterval = {
          start: form.values.dateFrom,
          end: isMultidayMode ? form.values.dateTo : form.values.dateFrom,
          startTime: form.values.timeFrom,
          endTime: form.values.timeTo,
        };
        userTagId = value ? value.id : '';
        onGuestTagsChange(value);
        break;
      default:
        dateInterval = {
          start: form.values.dateFrom,
          end: isMultidayMode ? form.values.dateTo : form.values.dateFrom,
          startTime: form.values.timeFrom,
          endTime: form.values.timeTo,
        };
        userTagId = form.values.firstname ? form.values.firstname.id : '';
    }
    const dateToParse = {
      dateFrom: dateInterval.start,
      dateTo: dateInterval.end,
      startTime: dateInterval.startTime,
      endTime: dateInterval.endTime,
    };
    dateHasBeenChanged(dateToParse, userTagId, resourceName, page);
  }

  /* async onResourceFilterChange(value) {
    const { dispatch, form } = this.props;
    const { filterTimeout } = this.state;
    if (filterTimeout) clearTimeout(filterTimeout);
    this.setState({
      filterTimeout: setTimeout(() => {
        this.onHandleChange(null, null, value);
      }, 500),
    });
  } */

  fetchMoreAvailableResource(page) {
    const { form, onFetchMoreAvailableResources } = this.props;
    const dateToParse = {
      dateFrom: form.values.dateFrom,
      dateTo: form.values.dateTo,
      startTime: form.values.timeFrom,
      endTime: form.values.timeTo,
    };
    const userTagId = form.values.firstname ? form.values.firstname.id : '';
    const formattedDates = formatter.formatOutputData(formatter.RESERVATION_DATES, dateToParse);
    const { dateFrom, dateTo } = formattedDates;
    const availableResourcesData = { userTagId, dateFrom, dateTo };
    const pageSize = 20;
    const append = true;
    onFetchMoreAvailableResources(page, pageSize, availableResourcesData, append );
  }

  getDisabledHours() {
    const { form } = this.props;
    if (form && form.values && form.values.dateFrom && moment(form.values.dateFrom).startOf('day').isSame(moment().startOf('day'))) {
      return _.times(moment().hour(), i => i);
    }
    return [];
  }

  getDisabledMinutes(selectedHour) {
    const { form } = this.props;
    if (form && form.values && form.values.dateFrom && moment(form.values.dateFrom).startOf('day').isSame(moment().startOf('day')) && selectedHour === moment().hour()) {
      return _.times(moment().minute(), i => i);
    }
    return [];
  }

  onSelectResource(resourceId) {
    const { availabileResources, dispatch } = this.props;
    const selectedResource = availabileResources && availabileResources.content && _.find(availabileResources.content, res => res.id === resourceId);
    if (selectedResource && selectedResource.automaticCheckIn) {
      dispatch(change('ReservationForm', 'checkInNotNecessary', true));
    }
  }

  toggleMultidayMode = () => {
    const { dispatch, form } = this.props;
    this.setState(prevState => {
      const newState = { isMultidayMode: !prevState.isMultidayMode };
      if (!newState.isMultidayMode && form.values.dateTo) {
        // Reset dateTo to dateFrom when switching back to single day
        dispatch(change('ReservationForm', 'dateTo', form.values.dateFrom));
      }
      return newState;
    });
  }

  render() {
    const { availabileResources, isGuestReservation, availableUserTags, guestsFilteredByTags, onGuestInputChange, form, onFetchMoreAvailableResources, multidayEnabled, availableResourcesContainerStyle  } = this.props;
    const { isMultidayMode } = this.state;
    const selectedResource = availabileResources && availabileResources.content && form && form.values && form.values.resourceId && _.find(availabileResources.content, res => res.id === form.values.resourceId);
    const isAutomaticCheckin = selectedResource && selectedResource.automaticCheckIn;
    return (
      <Form>
        <FormFlatContainer
          title="reservationInfo"
          subtitle="reservationInfoDescription"
          containerStyle={{ marginRight: 10, marginTop: 0 }}
          icon={<AgendaIconCustom style={{ width: 22 }} />}
        >
          <Entity
            componentClass={Field}
            name="title"
            componentAttribute="placeholder"
            entity="insertTitle"
            title={<Entity entity="reservationName" />}
            component={CustomField}
          />
        </FormFlatContainer>
        {!isGuestReservation && (
          <FormFlatContainer
            title="selectUser"
            subtitle="userWarning"
            containerStyle={{ marginRight: 10 }}
            icon={<UserOutlineIconCustom style={{ width: 22 }} />}
          >
            <Field
              title={<Entity entity="insertName" />}
              id="first"
              name="firstname"
              singleTag
              tags={availableUserTags}
              guests={guestsFilteredByTags}
              placeholder={<Entity entity="insertGuestTagsForCard" />}
              component={GuestSelector}
              onInputChange={value => onGuestInputChange(value)}
              onHandleChange={value => this.onHandleChange(value, 'firstname')}
              mandatory
            />
          </FormFlatContainer>
        )}
        <FormFlatContainer
          title="reservationDateAndTime"
          subtitle="dateAndTimeWarning"
          containerStyle={{ marginRight: 10 }}
          icon={<CalendarClockIconCustom style={{ width: 22 }} />}
        >
          {multidayEnabled && (
            <div style={{ 
              marginBottom: 24,
              padding: '16px 24px',
              backgroundColor: '#f8f9fa',
              borderRadius: 12,
              border: '1px solid #e9ecef'
            }}>
              <Field
                name="isMultiday"
                label={<Entity entity="enableMultidayReservation" />}
                titleStyle={{ fontSize: 16, fontWeight: 600, color: '#2c3e50' }}
                component={MDCheckBoxField}
                onChange={this.toggleMultidayMode}
                value={isMultidayMode}
              />
              <h4 style={{ 
                marginTop: 8, 
                marginBottom: 0,
                lineHeight: 1.5, 
                marginLeft: 35, 
                fontSize: 14, 
                color: '#6c757d', 
                fontWeight: 400 
              }}>
                <Entity entity="enableMultidayReservationDescription" />
              </h4>
            </div>
          )}
          
          {/* Single Card with Date Row and Time Row */}
          <div style={{
            padding: '24px',
            backgroundColor: '#ffffff',
            borderRadius: 12,
            border: '2px solid #e3f2fd',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
            marginBottom: 24
          }}>
            {/* Dates Row */}
            <div style={{ marginBottom: 24 }}>
              <div style={{ 
                display: 'grid',
                gridTemplateColumns: isMultidayMode ? 'repeat(auto-fit, minmax(200px, 1fr))' : '1fr',
                gap: 20
              }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <Field
                    title={<Entity entity="startDate" />}
                    id="dateFrom"
                    name="dateFrom"
                    dateContainer={{ width: '100%' }}
                    onHandleChange={value => this.onHandleChange(value, 'dateFrom')}
                    component={DatePickerField}
                    isOutsideRange={date => date.isBefore(moment().startOf('day'))}
                    mandatory
                    titleStyle={{ 
                      marginBottom: 2, 
                      fontSize: 15, 
                      fontWeight: 600,
                      color: '#495057' 
                    }}
                  />
                </div>
                
                {isMultidayMode && (
                  <div style={{ flex: 1, minWidth: 200 }}>
                    <Field
                      title={<Entity entity="endDate" />}
                      id="dateTo"
                      name="dateTo"
                      dateContainer={{ width: '100%' }}
                      onHandleChange={value => this.onHandleChange(value, 'dateTo')}
                      component={DatePickerField}
                      isOutsideRange={date => {
                        const fromDate = form.values.dateFrom;
                        return date.isBefore(moment().startOf('day')) || (fromDate && date.isBefore(moment(fromDate)));
                      }}
                      mandatory
                      titleStyle={{ 
                        marginBottom: 10, 
                        fontSize: 15, 
                        fontWeight: 600,
                        color: '#495057' 
                      }}
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Divider */}
            <div style={{ 
              height: 1, 
              backgroundColor: '#e9ecef', 
              marginBottom: 24 
            }} />

            {/* Times Row */}
            <div>
              <div style={{ 
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: 20
              }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <Field
                    title={<Entity entity="reservationStartTime" />}
                    name="timeFrom"
                    // Default snap (:00/:15/:30/:45) is set in BookeyReserve; picker allows any minute
                    component={isGuestReservation ? NativeTimeInputField : TimePickerField}
                    onHandleChange={value => this.onHandleChange(value, 'timeFrom')}
                    titleStyle={{ 
                      marginBottom:2, 
                      fontSize: 15, 
                      fontWeight: 600,
                      color: '#495057' 
                    }}
                  />
                </div>
                
                <div style={{ flex: 1, minWidth: 200 }}>
                  <Field
                    title={<Entity entity="reservationEndTime" />}
                    name="timeTo"
                    component={isGuestReservation ? NativeTimeInputField : TimePickerField}
                    onHandleChange={value => this.onHandleChange(value, 'timeTo')}
                    titleStyle={{ 
                      marginBottom: 2, 
                      fontSize: 15, 
                      fontWeight: 600,
                      color: '#495057' 
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {isAutomaticCheckin ? (
            <div style={{ 
              display: 'flex', 
              flexDirection: 'row', 
              alignItems: 'center',
              padding: '16px 20px',
              backgroundColor: '#e8f5e9',
              borderRadius: 10,
              border: '1px solid #4caf50'
            }}>
              <CheckCircle style={{ color: GREEN, fontSize: 22, flexShrink: 0 }} />
              <h5 style={{ 
                color: '#2e7d32', 
                marginLeft: 12, 
                marginTop: 0,
                marginBottom: 0,
                fontSize: 15, 
                fontWeight: 600,
                lineHeight: 1.4
              }}>
                <Entity entity="resourceWithAutomaticCheckin" />
              </h5>
            </div>
          ) : (
            <>
              {!isGuestReservation ? (
                <div style={{ 
                  opacity: isAutomaticCheckin ? 0.5 : 1,
                  padding: '16px 20px',
                  backgroundColor: '#f8f9fa',
                  borderRadius: 10,
                  border: '1px solid #e9ecef'
                }}>
                  <Field
                    name="checkInNotNecessary"
                    label={<Entity entity="checkInNotNecessary" />}
                    titleStyle={{ fontSize: 15, fontWeight: 600, color: '#495057' }}
                    containerstyle={{ marginTop: 0 }}
                    disabled={isAutomaticCheckin}
                    component={MDCheckBoxField}
                  />
                  <h4 style={{ 
                    marginTop: 8, 
                    marginBottom: 0,
                    lineHeight: 1.5, 
                    marginLeft: 35, 
                    fontSize: 14, 
                    color: '#6c757d', 
                    fontWeight: 400 
                  }}>
                    <Entity entity="checkInNotNecessaryDecription" />
                  </h4>
                </div>
              ) : null}
            </>
          )}
        </FormFlatContainer>
        <div style={{ marginBottom: 65 }}>
          <FormFlatContainer
            title="availableResources"
            containerStyle={{ marginBottom: 250, marginRight: 10, ...availableResourcesContainerStyle }}
            icon={<CopyIconCustom style={{ width: 22 }} />}
          >
            <Field
              name="resourceId"
              component={SelectableRowField}
              options={availabileResources}
              emptyOptionsText={<Entity entity="availableResourcesSelectDates" />}
              onFilterChange={(value) => this.onResourceFilterChange(value)}
              onFetchMoreItems={(page) => this.fetchMoreAvailableResource(page)}
              onHandleChange={(resourceId) => this.onSelectResource(resourceId)}
              isSingleChoice
              mandatory
            />
          </FormFlatContainer>
        </div>
      </Form>
    );
  }
} 

export default ReservationForm;
